import { createSlice } from "@reduxjs/toolkit";

import { getEmployeesDetails } from "../actions/employeeActions";
import { EmployeeDetailsState } from "../states/EmployeeDetailsState";

const initialState: EmployeeDetailsState = {
  employeeDetails: [],
  loadingStatus: "NotLoaded",
};

const EmployeeDetailsSlice = createSlice({
  name: "EmployeeDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEmployeesDetails.pending, (state) => {
        state.loadingStatus = "Loading";
      })
      .addCase(getEmployeesDetails.fulfilled, (state, action) => {
        state.loadingStatus = "Loaded";
        state.employeeDetails = action.payload;
      })
      .addCase(getEmployeesDetails.rejected, (state) => {
        state.loadingStatus = "Failed";
      });
  },
});

export default EmployeeDetailsSlice.reducer;
